// Generated by ts-to-zod
import { z } from 'zod'

import {
  IMAGE_CHOICE_UI_SUBTYPE,
  BUTTON_CHOICE_LAYOUT_TYPE
} from './../../../types/next/choices'
import { imagePurposeSchema } from './enums.zod'
import { imageIdSchema } from './ids.zod'

export const imageChoiceUiSubtypeSchema = z.nativeEnum(IMAGE_CHOICE_UI_SUBTYPE)

export const choiceSchema = z.object({
  value: z.string(),
  label: z.string().optional().nullable()
})

export const buttonChoiceLayoutTypeSchema = z.nativeEnum(
  BUTTON_CHOICE_LAYOUT_TYPE
)

const iconConfigSchema = z.any()

const imageDimensionSchema = z.any()

export const iconChoiceSchema = choiceSchema.extend({
  icon: iconConfigSchema.optional()
})

export const imageChoiceSchema = iconChoiceSchema
  .extend(choiceSchema.shape)
  .extend({
    image: z
      .object({
        id: imageIdSchema,
        purpose: imagePurposeSchema,
        url: z.string(),
        dimensions: imageDimensionSchema.optional(),
        alt: z.string().optional().nullable()
      })
      .optional()
  })

export const anyChoiceSchema = z.union([
  choiceSchema,
  iconChoiceSchema,
  imageChoiceSchema
])
